document.addEventListener('DOMContentLoaded', () => {
  let hiding;
  let hide;

  // Check if landing has been shown this session
  const landingShown = sessionStorage.getItem('landingShown');
  
  // Check if landing container exists and is visible
  const landingContainer = document.querySelector('.landing__container');
  if (!landingContainer || landingContainer.classList.contains('hide') || getComputedStyle(landingContainer).display === 'none' || landingShown === 'true') {
    // Landing not visible or already shown, restore scrolling immediately
    document.body.style = "overflow: visible; height: auto;";
    const header = document.querySelector('.main-header-container');
    if (header) header.classList.add('sticky');
    if (landingContainer) landingContainer.classList.add('hide');
    return;
  }

  // Mark landing as shown in this session
  sessionStorage.setItem('landingShown', 'true');

  document.querySelector('.css-typing').addEventListener('click', () => {
    clearTimeout(hiding);
    clearTimeout(hide);
    let landingContainer = document.querySelector('.landing__container')
    let landingText = document.querySelector('.css-typing p')
    landingText.classList.add('hiding')
    landingContainer.classList.add('hiding')
    setTimeout(() => {
      document.body.style = "overflow: visible; height: auto;"
      let header = document.querySelector('.main-header-container')
      let landingContainer = document.querySelector('.landing__container')
      landingContainer.classList.add('hide')
      header.classList.add('sticky')
    }, 1500)
  })

  hiding = setTimeout(() => {
    let landingContainer = document.querySelector('.landing__container')
    let landingText = document.querySelector('.css-typing p')
    landingText.classList.add('hiding')
    landingContainer.classList.add('hiding')
  }, 8500)
  hide = setTimeout(() => {
    document.body.style = "overflow: visible; height: auto;"
    let header = document.querySelector('.main-header-container')
    let landingContainer = document.querySelector('.landing__container')
    landingContainer.classList.add('hide')
    header.classList.add('sticky')
  }, 10000)
})

